import { render, staticRenderFns } from "./WsInfoFiles.vue?vue&type=template&id=2a956640&"
import script from "./WsInfoFiles.vue?vue&type=script&lang=js&"
export * from "./WsInfoFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports